import { createFileRoute, redirect } from '@tanstack/react-router'

import { authRecoveryHref } from '~/lib/auth/redirect'
import { createSessionQuery } from '~/lib/session-query'

export const Route = createFileRoute('/dashboard')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.ensureQueryData(
      createSessionQuery(context.queryClient),
    )

    if (!session?.session) {
      throw redirect({
        href: authRecoveryHref(location),
        replace: true,
      })
    }

    throw redirect({ href: '/matches', replace: true })
  },
})
